<template>
  <div class="roles-panel">
    <div class="el-search vue-top-padding radius">
      <div class="el-left">
        <el-button type="primary" size="small" v-hasPerm="['sys:role:insert']" icon="el-icon-plus" @click="appendRole">{{
          $t("common.add")
        }}</el-button>
      </div>
    </div>
    <div class="vue-padding radius">
      <el-table
        :data="roleList"
        v-loading="loading"
        row-key="id"
        :empty-text="$t('common.noData')"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column prop="sort" :label="$t('teamHub.displayOrder')" sortable :align="'center'" width="140"></el-table-column>
        <el-table-column prop="name" :label="$t('role.name')" sortable :align="'center'"></el-table-column>
        <el-table-column
          prop="createTime"
          :formatter="(row) => $formatDate(row.createTime)"
          :label="$t('role.createTime')"
          sortable
          :align="'center'"
        ></el-table-column>
        <el-table-column :label="$t('common.operate')" fixed="right" :width="operateWidth" :align="'center'">
          <template slot-scope="scope">
            <el-button size="mini" type="text" v-hasPerm="['sys:role:update']" @click="modify(scope.row)">{{
              $t("common.edit")
            }}</el-button>
            <el-button size="mini" type="text" v-hasPerm="['sys:role:delete']" @click="remove(scope.row)">{{
              $t("common.delete")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="loadRole"
      ></el-pagination>
    </div>

    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="roleStatus ? $t('role.add') : $t('role.edit')"
      :visible.sync="dialogRole"
      width="50%"
      top="9vh"
      @open="openRole"
      @closed="closedRole"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-form ref="roleData" :label-position="labelPosition" :model="roleData" label-width="80px">
          <el-row :gutter="20">
            <el-col :span="12" style="margin: 0">
              <el-form-item :label="$t('role.name')" prop="name">
                <el-input v-model="roleData.name" :placeholder="$t('role.pName')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="margin: 0">
              <el-form-item :label="$t('teamHub.displayOrder')" prop="sort">
                <el-input-number v-model="roleData.sort" controls-position="right" :min="1" :max="10"></el-input-number>
                <p class="rp-hint">{{ $t("teamHub.displayOrderHint") }}</p>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRole = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="addRole('roleData')">{{ $t("common.definite") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // 角色列表 + 增/改/删：逻辑来源于 Role.vue（原文件保持不动，路由深链接仍可用）。
  // 角色权限统一在「权限」分段（线上的 Functional authority）里配置，这里只做角色的增改删。

  export default {
    name: "RolesPanel",
    props: {
      canAuthorization: Boolean
    },
    data() {
      return {
        loading: false,
        loadingForm: false,
        dialogRole: false,
        roleStatus: false,
        labelPosition: "top",
        roleData: {
          id: "",
          name: "",
          sort: ""
        },
        roleList: [],
        page: {
          pageSize: 10,
          pageIndex: 1
        },
      };
    },
    computed: {
      operateWidth() {
        const base = 155;
        return this.$i18n.locale === "zh_CN" ? base : base + 20;
      }
    },
    mounted() {
      this.loadRole();
    },
    methods: {
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.loadRole();
      },
      // 加载角色信息（与 Role.vue 的 loadRole 一致）
      loadRole(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        this.$api
          .request(this.$url.AuthorityRole.load, this.$method.get, {
            type: 0,
            ...this.page
          })
          .then(res => {
            if (res.code === 0) {
              this.roleList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      appendRole() {
        this.roleData.sort = this.roleList.length + 1;
        this.dialogRole = true;
        this.roleStatus = true;
      },
      modify(data) {
        this.roleData.id = data.id;
        this.roleData.name = data.name;
        this.roleData.sort = data.sort;
        this.roleStatus = false;
        this.dialogRole = true;
      },
      remove(data) {
        let text = data.pid === "0" ? this.$t("role.delAll") : this.$t("role.del");
        this.$confirm(text, this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.AuthorityRole.delete, this.$method.delete, {
              id: data.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t("role.delS"));
                this.loadRole();
              }
            });
        });
      },
      addRole(role) {
        this.$refs[role].validate(valid => {
          if (valid) {
            let url = this.$url.AuthorityRole.save;
            let method = this.$method.post;
            if (this.roleData.id) {
              url = this.$url.AuthorityRole.update;
              method = this.$method.put;
            }
            this.loadingForm = true;
            this.$api
              .request(url, method, this.roleData)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t("role.addS"));
                  this.dialogRole = false;
                  this.loadRole();
                }
                this.loadingForm = false;
              })
              .catch(() => {
                this.$message.error(this.$t("role.addE"));
                this.loadingForm = false;
              });
          } else {
            return false;
          }
        });
      },
      openRole() {},
      closedRole() {
        this.clearValidate("roleData");
        this.$toolUtil.clearForm(this.roleData);
      },
      clearValidate(formName) {
        this.$refs[formName].clearValidate();
      }
    }
  };
</script>

<style scoped lang="scss">
  /* 表单内说明文字 */
  .rp-hint {
    margin: 2px 0 0;
    font-size: 12px;
    line-height: 1.45;
    color: var(--vtm-ink-3);
  }
  .rp-next {
    margin: 0;
    padding: 8px 10px;
    border-radius: var(--vtm-r-sm);
    background: var(--vtm-mint-soft);
    font-size: 12.5px;
    color: var(--vtm-mint-ink);
  }
</style>
